export const baseURL = "https://api.metricinfo.com";
// export const baseURL = "https://metricinfoapi.betaphase.in";
